import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { CATALOG_BLOCKS, DECO_CRUMBS } from './salesData';

/**
 * PRODUCTO. Qué es exactamente: 2 tomos, 100 recetas repartidas en 5
 * categorías comerciales. Cada categoría tiene su propio universo visual,
 * pero la sección se mantiene compacta y escaneable.
 */
export function CatalogSection() {
  return <section id="catalogo" className="relative scroll-mt-24 overflow-hidden bg-bone pb-0 pt-14 sm:pt-20" aria-labelledby="catalog-title" data-id="element-69" data-mp="22cvtmeanbt1w">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-70" data-mp="1xgeu6nxzxs9i">
        <div className="grid gap-9 lg:grid-cols-12 lg:gap-14" data-id="element-71" data-mp="2ca9yrhr4cvew">
          <div className="lg:col-span-5" data-id="element-72" data-mp="27cro9mxge84s">
            <SectionTag data-id="element-73" data-mp="27dt7wfsjc2y4">El catálogo</SectionTag>
            <h2 id="catalog-title" className="mt-4 font-display text-[1.95rem] leading-[1.06] text-charcoal sm:text-[2.7rem]" data-id="element-74" data-mp="hxk1cq1jl42r">
              2 tomos. 100 recetas. Un catálogo entero de cookies.
            </h2>
            <p className="mt-4 max-w-md font-sans text-[0.95rem] leading-relaxed text-charcoal/65" data-id="element-75" data-mp="2hdiwqzvgqs0h">
              No es una selección de diez recetas repetidas. Son cien variedades distintas,
              ordenadas por su rol comercial: las que sostienen la venta diaria, las que enamoran al
              partirse y las que suben el ticket.
            </p>
          </div>

          <ul className="lg:col-span-7" data-id="element-76" data-mp="3038ofe3xixo6">
            {CATALOG_BLOCKS.map((block, index) => <motion.li key={block.id} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.4
          }} transition={{
            duration: 0.28,
            ease: [0.23, 1, 0.32, 1],
            delay: Math.min(index, 4) * 0.035
          }} className="flex items-center gap-4 border-b border-warm/80 py-4 first:border-t sm:gap-6 sm:py-5" data-id="element-77" data-mp="350qzpb5f5ozc" data-mpi={index}>
                <img src={block.image} alt={block.alt} loading="lazy" decoding="async" className="h-16 w-16 shrink-0 rounded-full object-cover shadow-bakery-sm sm:h-[5.5rem] sm:w-[5.5rem]" data-id="element-78" data-mp="2mzwf8u8mfuyd" />
                <div className="min-w-0" data-id="element-79" data-mp="2qzx3f6livkim">
                  <div className="flex items-baseline gap-2.5" data-id="element-80" data-mp="2r31dulpkzchq">
                    <span className="font-display text-[1.6rem] leading-none tabular-nums text-caramel sm:text-[2.1rem]" data-id="element-81" data-mp="35wecfr68on20">
                      {block.count}
                    </span>
                    <h3 className="font-display text-[1.02rem] leading-tight text-charcoal sm:text-[1.3rem]" data-id="element-82" data-mp="3ep7yc7g6ykou">
                      {block.title}
                    </h3>
                  </div>
                  <p className="mt-1.5 max-w-lg font-sans text-[0.85rem] leading-relaxed text-charcoal/55 sm:text-[0.92rem]" data-id="element-83" data-mp="3opi8tkaude0b">
                    {block.body}
                  </p>
                </div>
              </motion.li>)}
          </ul>
        </div>
      </div>

      {/* Migas y chips como textura de cierre, cruzando hacia la sección siguiente. */}
      <img src={DECO_CRUMBS} alt="" aria-hidden loading="lazy" className="pointer-events-none mt-10 h-14 w-full object-cover opacity-70 mix-blend-multiply sm:h-20" data-id="element-84" data-mp="3td87gpqkkzu9" />
    </section>;
}